export default __webpack_public_path__ + "static/media/GourmetTasting.b56ae3f3.jpg";